// Фильтры
export const statusOptions = [
    {
        name: "Без ошибок",
        id: "completed",
        value: false
    },
    {
        name: "С ошибкой",
        id: "error",
        value: false,
    },
    {
        name: "Требует настройки",
        id: "manual",
        value: false
    },
    {
        name: "В обработке",
        id: "processing",
        value: false
    },
];

export const stateOptions = [
    {
        name: "Включены",
        id: "true",
        value: false
    },
    {
        name: "Отключены",
        id: "false",
        value: false
    }
];

export const typeOptions = [
    {
        name: "RSS",
        id: "rss",
        value: false,
    },
    {
        name: "Page",
        id: "page",
        value: false,
    },
    {
        name: "Vkontakte",
        id: "vkontakte",
        value: false,
    },
    {
        name: "Instagram",
        id: "instagram",
        value: false,
    },
    {
        name: "Facebook",
        id: "facebook",
        value: false,
    },
    {
        name: "Telegram",
        id: "telegram",
        value: false,
    },
    {
        name: "Twitter",
        id: "twitter",
        value: false,
    },
    {
        name: "Dzen",
        id: "dzen",
        value: false,
    },
    {
        name: "Youtube",
        id: "youtube",
        value: false,
    }
];

export const languageOptions = [
    {
        name: "RU",
        id: "ru",
        value: false
    },
    {
        name: "EN",
        id: "en",
        value: false
    }
];

//


export const levelSmiItems = [
    "Федеральный", "Региональный", "Местный", "Международный", "Центральный"
];

export const categorySmiItems = [
    "Газеты / журналы", "Информагентства", "Блоги", "ТВ/Радио"
];

export const psmiItems = [
    "Ритейл", "Транспорт", "Нефть и газ", "Фармацевтика"
];

export const tagsItems = [
    "Саммит", "“!4ООН”", "/ООН/"
];

export const templates = [
    "rss", "page", "vkontakte", "instagram", "facebook", "telegram", "twitter", "dzen", "youtube"
];

export const tableDataHeaders = (
    [
        {
            name: "name",
            title: "Имя",
            width: "250",
            minWidth: "230",
            type: "text",
            readonly: false,
            useFilter: false,
            useSort: true,
            hide: false
        },
        {
            name: "start_url",
            title: "Start Url",
            width: "268",
            minWidth: "268",
            type: "text",
            readonly: false,
            useFilter: false,
            useSort: true,
            hide: false
        },

        {
            name: "feed_url",
            title: "Feed url",
            width: "370",
            minWidth: "300",
            type: "text",
            readonly: false,
            useFilter: false,
            useSort: true,
            hide: false
        },
        {
            name: "isEnabled",
            title: "Отключение",
            width: "97",
            minWidth: "92",
            type: "checkbox",
            readonly: true,
            useFilter: false,
            useSort: true,
            hide: false
        },
        {
            name: "type",
            title: "Тип",
            width: "140",
            minWidth: "140",
            type: "dropdown",
            readonly: true,
            useFilter: true,
            useSort: false,
            hide: false
        },
        {
            name: "tags",
            title: "Теги",
            width: "340",
            minWidth: "322",
            type: "list",
            readonly: true,
            useFilter: false,
            useSort: false,
            hide: false
        },
        {
            name: "cron",
            title: "Частота обновления",
            width: "240",
            minWidth: "240",
            type: "cron",
            readonly: true,
            useFilter: false,
            useSort: false,
            hide: false
        },
        {
            name: "language",
            title: "Язык",
            width: "150",
            minWidth: "150",
            type: "text",
            filterOptions: "languageOptions",
            filterName: "Language",
            readonly: true,
            useFilter: false,
            useSort: true,
            hide: false
        },
    ]
);